import { ERole } from './_constants/role.constant';
import { InjectionToken, Provider } from '@angular/core';

interface SpecialRoleConfig {
  rol: ERole;
  url: string[];
}

export interface AuthConfig {
  allowedRoles: ERole[];
  urlRedirect: string[];
  specialRolesConfig: SpecialRoleConfig[] | null | undefined;
}

export const DEFAULT_AUTH_CONFIG: AuthConfig = {
  allowedRoles: [
    ERole.ROLE_CLIENTE,
    ERole.ROLE_CLIENTE_CHECKOUT,
    ERole.ROLE_CLIENTE_LIQ,
  ],
  urlRedirect: ['home'],
  specialRolesConfig: [],
};

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_AUTH_CONFIG,
});

/**
 *
 * Provide a custom config for AuthModule to manage routes, roles and access
 *
 * OK
 * @param config Custom config, managing other by default.
 * @returns A complete Angular provider for the Helipagos Auth Module.
 */
export function provideAuthConfig(config?: Partial<AuthConfig>): Provider {
  return {
    provide: AUTH_CONFIG,
    useValue: {
      ...DEFAULT_AUTH_CONFIG,
      ...config,
    },
  };
}
